module.exports = __webpack_public_path__ + "assets/5d2df511b315a2bb7b723ab172e12f97.woff";